export abstract class LocaleDeserializer {
  public static parseLocales(source: string): Locale[] {
    const parts = source.split(';;');
    if (parts.length < 1) {
      throw Error(`Invalid locale format: ${source}`);
    }
    const result: Locale[] = [];
    parts.forEach((x) => {
      result.push({
        locale: x,
        languageCode: x.substring(0, 2)
      });
    });
    return result;
  }
}

export interface Locale {
  locale: string;
  languageCode: string;
}
